{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(".faqs__rows .accordion_cus");
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".faqs__rows .acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelectorAll(".faqs__rows .acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(".accordion_cus");
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".acco_cus_item");
      // if (items.length > 0) {
      //   items[0].classList.add("open");
      // }
      items.forEach((item) => {
        const header = item.querySelector(".acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}
// Nutrition PopUp

document.addEventListener("DOMContentLoaded", function () {
  const zoomBtn = document.querySelectorAll('.zoom-nutrition');
  const ovrly = document.querySelectorAll('.gallery-ovrly, .close-gallery ');
  const gallery = document.querySelector('.nutrition-gallery');


  function updateImg(element) {
    const selectImg = element.querySelector('img').getAttribute('src');

    if (selectImg) {
      
      gallery.querySelector('img').setAttribute('src', selectImg);
      gallery.classList.add('active')
    }

    ovrly.forEach((ovly) => {
      ovly.addEventListener('click', (e) => {
        gallery.classList.remove('active');
      })
    })
  }

  zoomBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const parent = btn.parentElement;
      updateImg(parent)
    })
  })

});


document.addEventListener("DOMContentLoaded", function() {
  // Better selector to target all cart icons site-wide
  const cartIcons = document.querySelectorAll(".template-cart .navlink--cart, .template-cart .cart-icon, .template-cart [href='/cart']");
  
  if (cartIcons.length > 0) {
    cartIcons.forEach(icon => {
      icon.addEventListener("click", function(e) {
        // Only prevent default if it's actually a link
        if (this.tagName === 'A' || this.href) {
          e.preventDefault();
        }
        // More reliable way to navigate to cart
        window.location.href = '/cart';
        
        // Optional: Add visual feedback
        this.classList.add('clicked');
        setTimeout(() => this.classList.remove('clicked'), 200);
      });
    });
  }
});

// Video play and pause

document.addEventListener("DOMContentLoaded", function () {
  const videoBoxes = document.querySelectorAll(".why-choose-video-box");
  let currentlyPlaying = null;

  videoBoxes.forEach((box) => {
    const video = box.querySelector("video");
    const playBtn = box.querySelector(".video-playBtn");

    // Click handler for play button
    playBtn.addEventListener("click", function () {
      // If this video is already playing, pause it
      if (currentlyPlaying === video) {
        video.pause();
        box.classList.remove("active");
        playBtn.classList.remove("active");
        currentlyPlaying = null;
        return;
      }

      // Pause any currently playing video and remove active class
      if (currentlyPlaying) {
        currentlyPlaying.pause();
        currentlyPlaying
          .closest(".why-choose-video-box")
          .classList.remove("active");
        currentlyPlaying
          .closest(".why-choose-video-box")
          .querySelector(".video-playBtn")
          .classList.remove("active");
      }

      // Play this video and add active class
      video.play();
      box.classList.add("active");
      playBtn.classList.add("active");
      currentlyPlaying = video;
    });

    // Update when video is paused
    video.addEventListener("pause", function () {
      if (currentlyPlaying === video) {
        box.classList.remove("active");
        playBtn.classList.remove("active");
        currentlyPlaying = null;
      }
    });

    // Update when video ends
    video.addEventListener("ended", function () {
      box.classList.remove("active");
      playBtn.classList.remove("active");
      currentlyPlaying = null;
    });
  });
});

{
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".flavour-tabs").forEach((tabsContainer) => {
      const tabsNav = tabsContainer.querySelectorAll(
        ".flavour-tabs-header span"
      );
      const tabsContent = tabsContainer.querySelectorAll(
        ".flavour-tabs-content .collection-products-tabs"
      );
      if (tabsNav.length > 0) {
        tabsNav[0].classList.add("active");
      }
      if (tabsContent.length > 0) {
        tabsContent[0].classList.add("active");
      }
      tabsNav.forEach((items, ind) => {
        items.addEventListener("click", () => {
          tabsNav.forEach((remove) => remove.classList.remove("active"));
          items.classList.add("active");

          tabsContent.forEach((content) => content.classList.remove("active"));
          tabsContent[ind].classList.add("active");
        });
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tabs_In_sec").forEach((tabsContainer) => {
    const tabsNav = tabsContainer.querySelectorAll(".tabs_Ingredients ul li");
    const tabsContent = tabsContainer.querySelectorAll(
      ".ingr_wrapper .Ingredients_rows"
    );
    const ingredientsCharts =
      tabsContainer.querySelectorAll(".Ingredients_chart");

    function hexToRgba(hex, opacity) {
      let r = parseInt(hex.substring(1, 3), 16);
      let g = parseInt(hex.substring(3, 5), 16);
      let b = parseInt(hex.substring(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    // Function to handle the active tab state
    function handleActiveTab(activeTab) {
      const index = Array.from(tabsNav).indexOf(activeTab);

      // Update navigation styles
      tabsNav.forEach((tab) => {
        tab.classList.remove("is_active");
        tab.style.color = "";
      });
      activeTab.classList.add("is_active");

      // Update colors
      const bgColor = activeTab.getAttribute("data-section-color");
      if (bgColor) {
        let rgbaColor = hexToRgba(bgColor, 0.5);
        tabsContainer.style.backgroundColor = rgbaColor;
        ingredientsCharts.forEach((ingredientChart) => {
          ingredientChart.style.backgroundColor = bgColor;
        });
        activeTab.style.setProperty("--x", bgColor);
        activeTab.style.color = bgColor;
      }

      // Update content visibility
      tabsContent.forEach((content) => content.classList.remove("is_active"));
      if (tabsContent[index]) {
        tabsContent[index].classList.add("is_active");
      }
    }

    // Check for existing active tab on page load
    let foundActive = false;
    tabsNav.forEach((tab) => {
      if (tab.classList.contains("is_active")) {
        handleActiveTab(tab);
        foundActive = true;
      }
    });

    // If no active tab found, activate the first one
    if (!foundActive && tabsNav.length > 0) {
      handleActiveTab(tabsNav[0]);
    }

    // Set up click handlers
    tabsNav.forEach((items) => {
      items.addEventListener("click", () => {
        handleActiveTab(items);
      });
    });
  });
});

{
  document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".accordion-item");
    if (accordionItems.length > 0) {
      accordionItems[0].classList.add("open");
    }
    accordionItems.forEach((item) => {
      const header = item.querySelector(".accordion-item-header");
      header.addEventListener("click", () => {
        document.querySelectorAll(".accordion-item").forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains("open")) {
            otherItem.classList.remove("open");
          }
        });
        item.classList.toggle("open");
      });
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const selectBox = document.querySelector(".cus__selctbox");
    const selected = selectBox.querySelector(".selected");
    const optionsContainer = selectBox.querySelector(".options");
    const options = selectBox.querySelectorAll(".option-wrp");
    const flavorImage = document.querySelector(".nf-flavor-nfp img");

    selected.addEventListener("click", () => {
      optionsContainer.classList.toggle("active");
    });

    options.forEach((option) => {
      option.addEventListener("click", () => {
        const color = option.getAttribute("data-color");
        const productImage = option.getAttribute("data-product-image");
        selected.innerHTML = "Flavor: " + option.textContent;
        if (color) {
          selected.style.background = color;
        }
        if (productImage && flavorImage) {
          flavorImage.src = productImage;
        }
        optionsContainer.classList.remove("active");
      });
    });
    document.addEventListener("click", (e) => {
      if (!selectBox.contains(e.target)) {
        optionsContainer.classList.remove("active");
      }
    });
    options.forEach((option) => {
      const color = option.getAttribute("data-color");
      const img = option.querySelector("img");
      if (color && img) {
        img.style.background = color;
      }
    });

    const fstrmove = document.querySelector(
      ".product__images .accordion-item.open"
    );
    if (fstrmove) {
      fstrmove.classList.remove("open");
    }
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const tabsList = document.querySelector(".tabs_Ingredients ul");
    const items = tabsList.querySelectorAll("li");

    tabsList.addEventListener("click", function (e) {
      if (window.innerWidth <= 768) {
        if (e.target.tagName.toLowerCase() === "li") {
          const clickedItem = e.target;
          items.forEach((li) => li.classList.remove("is_active"));
          clickedItem.classList.add("is_active");
          tabsList.classList.remove("open");
        } else {
          tabsList.classList.toggle("open");
        }
      }
    });

    document.addEventListener("click", function (e) {
      if (window.innerWidth <= 768 && !tabsList.contains(e.target)) {
        tabsList.classList.remove("open");
      }
    });
  });
}
// {
//   document.addEventListener("DOMContentLoaded", function () {
//     const row = document.querySelector(".daly_best_row");
//     if (row) {
//       row.addEventListener("scroll", function () {
//         document.querySelector(".foolow_mouse").style.opacity = "0";
//       });
//     }
//     const followMouse = document.querySelector(".foolow_mouse");
//     // let mouseX = 0;
//     // let mouseY = 0;
//     // document.addEventListener('mousemove', (e) => {
//     //   mouseX = e.clientX;
//     //   mouseY = e.clientY;
//     // });
//     function animate() {
//       // followMouse.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
//       requestAnimationFrame(animate);
//     }
//     animate();
//     document.addEventListener("mousedown", () => {
//       setTimeout(() => {
//         followMouse.style.opacity = "0";
//       }, 300);
//     });
//   });
// }
{
  document.addEventListener("DOMContentLoaded", function () {
    const content = document.querySelector(".product__description__content");
    const maxHeight = 120;
    const fullHeight = content.scrollHeight;
    content.style.maxHeight = maxHeight + "px";
    content.style.overflow = "hidden";
    const toggleButton = document.createElement("button");
    toggleButton.type = "button";
    toggleButton.className = "caps--link";
    toggleButton.innerHTML = "<span>Read More</span>";
    content.insertAdjacentElement("afterend", toggleButton);
    toggleButton.addEventListener("click", function () {
      const isCollapsed = content.style.maxHeight === maxHeight + "px";
      if (isCollapsed) {
        content.style.maxHeight = fullHeight + "px";
        toggleButton.querySelector("span").textContent = "Read Less";
      } else {
        content.style.maxHeight = maxHeight + "px";
        toggleButton.querySelector("span").textContent = "Read More";
      }
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelector(".product__slides");
    const slides = document.querySelectorAll(".product__slide");
    const nextBtn = document.querySelector(".slid-button-next");
    const prevBtn = document.querySelector(".slid-button-prev");

    const scroll = (dir) => {
      if (!slider || !slides.length) return;
      const currentScroll = slider.scrollLeft;
      const slide = slides[0];
      const style = window.getComputedStyle(slide);
      const slideWidth =
        slide.offsetWidth +
        parseInt(style.marginLeft) +
        parseInt(style.marginRight);
      let targetScroll = currentScroll + dir * slideWidth;
      targetScroll = Math.max(
        0,
        Math.min(targetScroll, slider.scrollWidth - slider.clientWidth)
      );
      if ("scrollBehavior" in document.documentElement.style) {
        slider.scrollTo({
          left: targetScroll,
          behavior: "smooth",
        });
      } else {
        slider.scrollLeft = targetScroll;
      }
    };
    const updateActive = () => {
      if (!slider || !slides.length) return;

      const containerCenter =
        slider.getBoundingClientRect().left + slider.clientWidth / 2;
      let closestSlide = null;
      let smallestDistance = Infinity;

      slides.forEach((slide) => {
        slide.classList.remove("media--active");
        const slideCenter =
          slide.getBoundingClientRect().left + slide.offsetWidth / 2;
        const distance = Math.abs(slideCenter - containerCenter);

        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestSlide = slide;
        }
      });

      if (closestSlide) {
        closestSlide.classList.add("media--active");
      }
    };
    nextBtn.addEventListener("click", () => {
      scroll(1);
      setTimeout(updateActive, 400);
    });

    prevBtn.addEventListener("click", () => {
      scroll(-1);
      setTimeout(updateActive, 400);
    });

    let isScrolling;
    slider.addEventListener("scroll", () => {
      window.clearTimeout(isScrolling);
      isScrolling = setTimeout(updateActive, 100);
    });

    updateActive();

    window.addEventListener("resize", () => {
      setTimeout(updateActive, 100);
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelector(".collection-products-tabs")
      .addEventListener("scroll", function () {
        var container = this;
        var label = document.querySelector(".falvors-scroll-label");
        if (
          container.scrollHeight - container.scrollTop ===
          container.clientHeight
        ) {
          label.style.display = "none";
        } else {
          label.style.display = "flex";
        }
      });
    document
      .querySelector(".falvors-scroll-label")
      .addEventListener("click", function () {
        var container = document.querySelector(".collection-products-tabs");
        container.scrollTo({
          top: container.scrollHeight,
          behavior: "smooth",
        });
      });
  });
}

 {
    document.addEventListener("DOMContentLoaded", function () {
      const items = document.querySelectorAll(".product_acco_cus_item");
      items.forEach((item) => {
        item.addEventListener("click", () => {
          if (item.classList.contains("open")) {
            item.classList.remove("open");
          } else {
            items.forEach((el) => el.classList.remove("open"));
            item.classList.add("open");
          }
        });
      });
    });
  }

  // CURVED TEXT

// const rotateTextDiv = document.querySelector('.rotateText');
// const text = rotateTextDiv.textContent.trim();
// const radius = parseInt(rotateTextDiv.dataset.radius) || 120;

// rotateTextDiv.innerHTML = '';

// const chars = text.split('');
// const angleStep = 140 / (chars.length - 1);

// chars.forEach((char, i) => {
//     const span = document.createElement('span');
//     span.textContent = char;

//     const angle = -70 + angleStep * i;

//     span.style.transform = `rotate(${angle}deg) translateY(-${radius}px)`;
//     rotateTextDiv.appendChild(span);
// });

const rotateTextDiv = document.querySelector('.rotateText');
const text = rotateTextDiv.textContent.trim();

// Function to calculate dynamic radius based on screen width
function getRadius() {
  if (window.innerWidth <= 480) {
    return 80; // Small circle on mobile
  } else if (window.innerWidth <= 768) {
    return 100; // Tablet size
  } else {
    return 120; // Desktop
  }
}

function renderCurvedText() {
  const radius = getRadius();
  rotateTextDiv.innerHTML = '';

  const chars = text.split('');
  const angleStep = 140 / (chars.length - 1);

  chars.forEach((char, i) => {
    const span = document.createElement('span');
    span.textContent = char;

    const angle = -70 + angleStep * i;
    span.style.position = 'absolute';
    span.style.left = '50%';
    span.style.top = '100%';
    span.style.transformOrigin = 'bottom center';
    span.style.transform = `rotate(${angle}deg) translateY(-${radius}px)`;

    rotateTextDiv.appendChild(span);
  });
}

// Initial render
renderCurvedText();

// Re-render on resize
window.addEventListener('resize', renderCurvedText);


// CURVED TEXT

{
    document.addEventListener("DOMContentLoaded", function () {
        const swiperWrapper = document.querySelector(
            ".full-sec-slider .swiper-wrapper"
        );
        // const slide = swiperWrapper.querySelector(".swiper-slide");

        // if (slide) {
        //     for (let i = 0; i < 10; i++) {
        //         let clone = slide.cloneNode(true);
        //         swiperWrapper.appendChild(clone);
        //     }
        // }

        var swiper = new Swiper(".full-sec-slider", {
            slidesPerView: 2,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 8000,
            breakpoints: {
                150: {
                    slidesPerView: 1.3,
                },
                576: {
                    slidesPerView: 1.7,
                },
                769: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: 2,
                },
            }
        });
    });
}



{
    document.addEventListener("DOMContentLoaded", function () {
        function faqsAccordion() {
            var accordionSections = document.querySelectorAll(".accordion-item");

            if (accordionSections.length > 0) {
                var firstAccordionItemHeader = accordionSections[0].querySelector(
                    ".accordion-item-header"
                );
                var firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

                if (firstAccordionItemBody) {
                    firstAccordionItemHeader.classList.add("active");
                    firstAccordionItemBody.style.maxHeight =
                        firstAccordionItemBody.scrollHeight + "px";
                }

                for (let i = 1; i < accordionSections.length; i++) {
                    var otherHeader = accordionSections[i].querySelector(".accordion-item-header");
                    var otherBody = otherHeader.nextElementSibling;

                    if (otherBody) {
                        otherHeader.classList.remove("active");
                        otherBody.style.maxHeight = "0";
                    }
                }
            }

            accordionSections.forEach((section) => {
                var accordionItemHeaders = section.querySelector(".accordion-item-header");
                var accordionItemBody = section.querySelector(".accordion-item-body");

                accordionItemHeaders.addEventListener("click", function () {
                    var currentlyActiveHeader = document.querySelector(
                        ".accordion-item-header.active"
                    );
                    var currentlyActiveBody = currentlyActiveHeader
                        ? currentlyActiveHeader.nextElementSibling
                        : null;

                    if (currentlyActiveHeader && currentlyActiveBody) {
                        currentlyActiveHeader.classList.remove("active");
                        currentlyActiveBody.style.maxHeight = 0;
                    }

                    if (accordionItemHeaders !== currentlyActiveHeader) {
                        accordionItemHeaders.classList.add("active");
                        accordionItemBody.style.maxHeight =
                            accordionItemBody.scrollHeight + "px";
                    } else {
                        accordionItemHeaders.classList.remove("active");
                        accordionItemBody.style.maxHeight = 0;
                    }
                });
            });
        }

        faqsAccordion();
    });
}
 